const property = {
  bedrooms:   "Спальни",
  bathrooms:  "Ванные",
  sqft:       "Кв. фут",
  type:       "Тип",
  description:"Описание",
  amenities:  "Удобства",
  details:    "Детали",
  developer:  "Застройщик",
  status:     "Статус",
  location:   "Расположение",
  size:       "Площадь",
  source:     "Источник",
  perYear:    "в год",
  viewAll_one:   "Смотреть {{count}} фото",
  viewAll_few:   "Смотреть {{count}} фото",
  viewAll_many:  "Смотреть {{count}} фото",
  viewAll_other: "Смотреть {{count}} фото",
  youMayLike: "Вам может понравиться",
  similar:    "Похожие",
  similarEm:  "объекты",
  whatsapp:   "Написать в WhatsApp",
  telegram:   "Telegram",
  notFound:   "Объект не найден",
  backToListings: "← Вернуться к объявлениям",
};

export default property;
